var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white-box"},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component, route: r }){return [_c('KeepAlive',[_c(Component,{key:r.name,tag:"component"})],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }